import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import GamesIndex from './gamesIndex';
import GamesRevenue from './revenue/gamesRevenue.js';
import GamesSwitcher from './gamesSwitcher.js';
import GamesForm from './gamesForm';
import GamesEdit from './gamesEdit';
import ExecutiveDashboardOverview from './executiveDashboardOverview';
import ExecutiveDashboard from './executiveDashboard';
import ExecutiveDashboardDetails from './executiveDashboardDetails';

export default angular.module('app.components.games', [
  'ui.router',
  GamesIndex.name,
  GamesForm.name,
  GamesEdit.name,
  GamesRevenue.name,
  GamesSwitcher.name,
  ExecutiveDashboard.name,
  ExecutiveDashboardOverview.name,
  ExecutiveDashboardDetails.name
])
  .config(function($stateProvider, $urlRouterProvider){
    $stateProvider
      .state('app.games.switcher', {
        url: '',
        template: '<games-switcher></games-switcher>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.games.index');
          }
        }
      })
      .state('app.games', {
        abstract: true,
        url: '',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous'],
            redirectTo: 'login'
          }
        }
      })
      .state('app.games.index', {
        url: '/dashboard',
        template: '<games-index></games-index>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.games.index');
          }
        }
      })
      .state('app.games.new', {
        url: '/new',
        template: '<games-edit></games-edit>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.games.new');
          }
        }
      })
      .state('app.games.revenue', {
        url: '/revenue',
        template: '<games-revenue></games-revenue>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.games.revenue');
          }
        }
      })
      .state('app.games.edit', {
        url: '/:id',
        template: '<games-edit></games-edit>',
        resolve: {
          $title: ($filter, $stateParams, GamesResource) => {
            return GamesResource.one($stateParams.id).get()
              .then((game) => $filter('translate')('$state.app.games.edit', {name: game.name}));
          }
        }
      });
  })



/** WEBPACK FOOTER **
 ** ./src/components/games/games.js
 **/